import { provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideStorageNamespace } from '@any2any/shared';
import { provideLuxonMaterial } from '@any2any/shared/datetime';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateCompiler } from '@ngx-translate/core';
import { createErrorHandler } from '@sentry/angular';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import { AppRoutingModule } from './app-routing.module';
import { appLocalization } from './app.localization';
import { ConfigService } from './core/services/config.service';
import { AppConfig } from './core/types/app-config';
import { SharedModule } from './shared/shared.module';

export function AppConfigFactory(config: AppConfig): ApplicationConfig {
  return {
    providers: [
      importProvidersFrom(
        BrowserModule,
        AppRoutingModule,
        FontAwesomeModule,
        SharedModule
      ),
      appLocalization.provideEnvironment({
        compiler: {
          provide: TranslateCompiler,
          useClass: TranslateMessageFormatCompiler
        }
      }),
      provideZoneChangeDetection(),
      provideHttpClient(),
      provideLuxonMaterial(),
      ConfigService.provide(config),
      provideStorageNamespace('platform.digital_signage'),
      provideAnimations(),
      {
        provide: ErrorHandler,
        useValue: createErrorHandler()
      }
    ]
  };
}
